<template>
  <div popup-clause v-if="clause" @click="close">
    <article>
      <a class="btn-x" @click="close"></a>
    </article>
  </div>
</template>

<script>
export default {
  name: 'PopupClause',
  computed: {
    clause() {
      if (!this.$store.state.clauseOn) return false;
      return this.$store.state.clauseOn;
    },
  },
  methods: {
    close(e) {
      if (e) e.stopPropagation();
      this.$store.commit('offClause');
    },
  },
};
</script>

<style lang="less">
  @import "../less/proj";
  .mob{
    [popup-clause]{ .fix; .t(0); z-index: 1000; .wh(100%); background:rgba(0,0,0,0.6); overflow: auto;
      article{.wh(700,1006); .abs; .l(50%); .t(50%); transform: translate(-50%,-50%); .contain("@{mob}/p2/popup-clause.png"); .m(50,0);
        .btn-x{.block; .wh(70,70); .r(0); .t(0); .abs;}
      }
    }
  }
  .pc{
    [popup-clause]{ .fix; .t(0); z-index: 1000; .wh(100%); background:rgba(0,0,0,0.6); overflow: auto;
      article{.wh(800px,1150px); .abs; .l(50%); .t(50%); transform: translate(-50%,-50%); .contain("@{pc}/p2/popup-clause.png"); .m(50px,0);
        .btn-x{.block; .wh(70px,70px); .r(0); .t(0); .abs;}
      }

      @media screen and (max-height: 1150px){
        article{.t(0); transform: translate(-50%,0);}
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PopupClause.vue